module.exports = __webpack_public_path__ + "img/btn_GDV_scoreBoard.28b8e612.svg";